import script from "./Slider.vue?vue&type=script&lang=ts&setup=true"
export * from "./Slider.vue?vue&type=script&lang=ts&setup=true"

import "./Slider.vue?vue&type=style&index=0&id=563bd2a0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563bd2a0"]])

export default __exports__